import styled from 'styled-components';

export const HR = styled.hr`
    background: #dbdbdb;
    height: ${props => props.height};
    boxshadow: 0px -5px 3px rgba(0, 0, 0, 0.3);
    border: 0px;
`;



// WEBPACK FOOTER //
// ./src/uic/HorizontalLine.js